/**
 * @file Route: inspirationsingleproductsfolder
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

 import "layouts/main";
 import { $all } from "@olmokit/dom";
 import { globalData } from "@olmokit/core/data";
 import { replaceFragment } from "@olmokit/core/fragments";
 import { FormType } from "components/Form";
 import projects from "components/VisualProjects";
 import "components/VisualQuote";
 import "components/VisualText";
 import slider from "components/VisualSlider";
 import products from "components/VisualProducts";
 import "./index.scss";

console.log("Route inspirationsingleproductsfolder/index.js mounted.");

replaceFragment("contactForm", "components.FormType").then(() => FormType());

const glideEl = $all(".glide");
if (glideEl.length > 0) {
    if (globalData.sliderproducts) {
        slider('.VisualSlider:'+globalData.sliderproducts);
    }
    if (globalData.visualproducts) {
        products('.VisualProducts:'+globalData.visualproducts);
    }
    if (globalData.sliderprojects) {
        projects('.VisualProjects:'+globalData.sliderprojects);
    }
}
